import ValidationComponentMixin from './mixins/validationComponent';
import DocumentTitleMixin from './mixins/documentTitle';
import CollectionMixin from './mixins/Collection';
import { updateTitle as DocumentTitleMixin__updateTitle} from './mixins/documentTitle';

export { DocumentTitleMixin, DocumentTitleMixin__updateTitle, ValidationComponentMixin, CollectionMixin }